module.exports = __webpack_public_path__ + "img/inst-14.715ecba9.png";